<template>
  <div>
    <validation-observer ref="legalEntityForm">
      <b-form @submit.prevent="saveLegalEntityForm"
              @reset.prevent="clearForm">

        <div class="vx-row">
          <div class="vx-col sm:w-1/3 w-full">
            <b-form-group
                label="CNPJ"
                label-for="cnpj">
              <validation-provider
                #default="{ errors }"
                name="CNPJ"
                rules="required|cnpj">
                <b-form-input
                  id="cnpj"
                  v-model="legalEntity.cnpj"
                  :state="errors.length > 0 ? false:null"
                  name="register-cnpj"
                  class="required"
                  v-mask="['##.###.###/####-##']"/>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </div>
          <div class="vx-col sm:w-2/3 w-full">
            <b-form-group
                label="Razão Social"
                label-for="company_name">
              <validation-provider
                #default="{ errors }"
                name="Razão Social"
                rules="required">
                <b-form-input
                  id="company_name"
                  v-model="legalEntity.company_name"
                  :state="errors.length > 0 ? false:null"
                  name="company_name"
                  class="required"/>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </div>

          <!-- <div class="vx-col sm:w-1/3 w-full mb-2">
            <b-form-checkbox v-model="legalEntity.own_place" class="mt-6">Sede própria</b-form-checkbox>
            <span
              class="text-danger text-sm"
              v-show="errors.has('company_name')"
            >{{ errors.first('company_name') }}</span>
          </div> -->
        </div>

        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full">
              <b-form-group
                  label="Nome Fantasia"
                  label-for="trading_name">
                <validation-provider
                  #default="{ errors }"
                  name="Nome Fantasia"
                  rules="required">
                  <b-form-input
                    id="trading_name"
                    v-model="legalEntity.trading_name"
                    :state="errors.length > 0 ? false:null"
                    name="trading_name"
                    class="required"/>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
          </div>
          <div class="vx-col sm:w-1/2 w-full">
            <b-form-group
              :label="$t('legal_entity.status')"
              label-for="status">
              <validation-provider
                #default="{ errors }"
                :name="$t('legal_entity.status')"
                rules="required">
                <b-form-radio-group
                  id="status"
                  v-model="legalEntity.status"
                  name="status"
                  :options="statusOptions"
                  class="required"/>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full">
            <b-form-group
              id="description"
              :label="$t('legal_entity.description')"
              label-for="description">
              <complex-editor :editor_data.sync="legalEntity.description"/>
            </b-form-group>
          </div>
        </div>
        <!-- Logo upload image -->
        <b-form-row :class="['justify-center', inline ? 'ml-auto' : '' ]" v-if="isEdit">
          <b-col cols="auto">
            <label class="w-full text-left block"> {{$t('logo_image')}} </label>
            <image-upload
              class="border-faint-grey border-solid border p-2 rounded-lg"
              maxHeight="100px"
              maxWidth="200px"
              hint="Tamanho recomendado: 1200×675px (paisagem, 16:9) — usada como capa do clube nos cards de busca e na página de detalhes."
              v-model="imageData"
              :key="logoUploadURL"
              :uploadUrl="logoUploadURL"
              @upload-complete="uploadLogoSuccess"/>
          </b-col>
        </b-form-row>

        <div class="vx-row mt-2 mb-2" v-if="!isComplement">
          <div class="vx-col w-full flex gap-2 justify-end">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="float-right"
              :disabled="!validateForm"
              type="submit">
              Salvar
            </b-button>
            <b-button type="reset" variant="outline-secondary" class="float-right">
                <slot name="reset-button-text">Limpar</slot>
              </b-button>
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="outline-secondary"
              @click="goBack"
              class="mr-2 float-right">
              Voltar
            </b-button>
          </div>
        </div>

      </b-form>
    </validation-observer>
  </div>
</template>


<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BForm, BFormRow, BCol, BButton, BFormInput, BFormGroup, BFormRadioGroup, BFormCheckbox
} from 'bootstrap-vue'
import { required, email } from '@validations'
import vSelect from 'vue-select'
import { VMoney } from 'v-money'
import ComplexEditor from '@/components/ComplexEditor.vue'
import ImageUpload from '@/components/ImageUpload.vue'

//Services
import LegalEntityService from '@/services/api/LegalEntityService'

export default {
  components: {
    vSelect,
    // BSV
    BForm,
    BFormRow,
    BCol,
    BButton,
    BFormInput,
    BFormGroup,
    BFormRadioGroup,
    BFormCheckbox,
    // validations
    ValidationProvider,
    ValidationObserver,
    ComplexEditor,
    ImageUpload
  },
  directives: { money: VMoney },
  props: {
    legalEntityId: {
      type: Number,
      default: null
    },
    legalEntity: {
      type: Object,
      default: {}
    },
    services: {
      type: Object,
      default: null
    },
    isComplement: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    federationUnit: null,
    federationUnitList: [],
    cityList: [],
    mainOfficeList: [],
    showSpousePopup: false,
    showImportModal: false,
    money: {
      decimal: ',',
      thousands: '.',
      prefix: 'R$ ',
      precision: 2,
      masked: false
    },
    statusOptions: [
      { text: 'Em cadastro', value: 'IR' },
      { text: 'Ativo', value: 'AC' },
      { text: 'Inativo', value: 'IN' },
      { text: 'Bloqueado', value: 'BL' },
    ],
  }),
  computed: {
    isEdit(){
      return this.legalEntityId != null
    },
    validateForm() {
      return (
        !this.isEmpty(this.legalEntity.cnpj) &&
        !this.isEmpty(this.legalEntity.trading_name) &&
        !this.isEmpty(this.legalEntity.company_name) &&
        !this.isEmpty(this.legalEntity.status)
      )
    },
    logoUploadURL() {
      const base = `${process.env.VUE_APP_API_BASE_URL}/api/v1`
      return `${base}/legal_entities/${this.legalEntityId}/logo`
    },
    imageData(){
      if(this.isEdit){
        return this._.get(this.legalEntity, 'logo_url')
      }
    }
  },
  methods: {
    saveLegalEntityForm() {

      this.$refs.legalEntityForm.validate().then(success => {

        if (success) {

          this.clearErrors(this.$refs.legalEntityForm)
          this.$vs.loading()

          const cnpj = !this.isEmpty(this.legalEntity.cnpj) ? this.clearDashDots(this.legalEntity.cnpj).replace('/', ''): ''

          const peopleId = _.get(this.legalEntity, 'people.id')
          const isCreate = peopleId === null
          //new unit in form legal entity, with add new unit, if case

          const params = {
              id: this.legalEntity.id,
              cnpj,
              trading_name: this.legalEntity.trading_name,
              company_name: this.legalEntity.company_name,
              status: this.legalEntity.status,
              description: this.legalEntity.description
            }
          this.services.legalEntityService.createOrUpdate(params).then(
              data => {
                this.legalEntity = data
                this.$vs.loading.close()
                this.notifySuccess(this.$vs)
                this.$emit('update-data', data)
              },
              error => {
                this.$vs.loading.close()
                this.showErrors(this.$validator, error, this)
                this.showErrors(this.$refs.legalEntityForm, error)
              }
            )
        }
      })
    },
    clearValidationErrors() {
      //this.$validator.reset()
    },
    clearForm() {
      this.$emit('reset')
      this.legalEntity.cnpj = ''
      this.legalEntity.company_name = ''
      this.legalEntity.trading_name = ''
      this.legalEntity.status = null
      this.legalEntity.description = ''
      this.clearValidationErrors()
    },
    goBack() {
      this.$router.push('/legal_entities')
    },
    uploadLogoSuccess() {
      this.notifySuccess(this.$vs, this.$t('messages.success'), 5000)
    },
  }, //End method
  created() {

  },
  beforeMount() {

  },
  mounted() {

  }
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
</style>

<style lang="scss" scoped>

</style>
